import React from 'react'
import { useHistory } from 'react-router'
import { ClipboardTick } from 'iconsax-react'
import { useTheme } from '@mui/material'

import { useTaskAPI } from '@SonarCX/providers/TaskAPIProvider'
import { Routes } from '@SonarCX/Routes'
import { ReminderItemProps } from '..'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from '../styles'

const ReminderTask: React.FC<ReminderItemProps> = ({ object_id }) => {
  const theme = useTheme()
  const classes = useStyles()
  const history = useHistory()
  const { tasks: allTasks, loaded: tasksLoaded, loadTask } = useTaskAPI()
  const fullTask = React.useMemo(
    () => allTasks[object_id] ?? null,
    [allTasks, object_id]
  )
  const navigate = () => {
    history.push(`${Routes.TASKS}/${object_id}`)
  }
  // Gets the full tasks
  React.useEffect(() => {
    if (!tasksLoaded || fullTask) {
      return
    }
    loadTask(object_id)
  }, [tasksLoaded, allTasks, loadTask, object_id, fullTask])

  if (!fullTask) return null

  return (
    <div className={classes.root} onClick={navigate}>
      <span className={classes.info}>
        <Tooltip title='Task'>
          <ClipboardTick
            size={theme.size.base}
            variant='Bulk'
            color={theme.palette.primary.main}
          />
        </Tooltip>
        <span className={classes.title}> {fullTask.title}</span>
      </span>
    </div>
  )
}

export default ReminderTask
